// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__mv0dM","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2VXIN","obliqueLine":"membershipbadge_obliqueLine__3BXX4"};